(function () {
  function prepareVideo(video) {
    if (!video) return;

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;

    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');
    video.setAttribute('preload', 'auto');

    var playPromise = video.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function playProductVideos() {
    var videos = document.querySelectorAll(
      '.product-media-video, .product__media video, .product-media video, .product__media-item video, .media video'
    );

    videos.forEach(prepareVideo);
  }

  document.addEventListener('DOMContentLoaded', playProductVideos);
  document.addEventListener('shopify:section:load', playProductVideos);

  document.addEventListener(
    'touchstart',
    function () {
      playProductVideos();
    },
    { once: true, passive: true }
  );

  document.addEventListener(
    'click',
    function () {
      playProductVideos();
    },
    { once: true }
  );

  var observer = new MutationObserver(function () {
    playProductVideos();
  });

  document.addEventListener('DOMContentLoaded', function () {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();